export function analyseAdjustPriceVos({ status, adjustPriceVos }) {
  const pendings = {};
  const rejecteds = {};
  let rejectRemark = "";
  if (status === 0 && adjustPriceVos?.length) {
    adjustPriceVos.forEach((adjusting) => {
      const { orderItemId, status } = adjusting;
      if (status === 0) {
        pendings[orderItemId] = adjusting;
      } else if (status === 2) {
        rejectRemark = adjusting.rejectRemark;
        rejecteds[orderItemId] = adjusting;
      }
    });
  }
  return {
    pendings,
    rejecteds,
    rejectRemark,
  };
}

export function getAdjustPriceStatus(order) {
  const { pendings, rejecteds, rejectRemark } = analyseAdjustPriceVos(order);
  return {
    pending: Object.values(pendings).length,
    rejected: Object.values(rejecteds).length,
    rejectRemark,
  };
}

export function analyseRefundVos({ status, orderRefundVos }) {
  const pendings = [];
  const rejecteds = [];
  const resolves = [];
  let rejectRemark = "";
  if (status >= 20 && orderRefundVos?.length) {
    orderRefundVos.forEach((refund) => {
      const {
        refundNo,
        refundAmount,
        refundStatus,
        approveComment,
        refundComment,
      } = refund;
      if (refundStatus === 2) {
        rejectRemark = approveComment;
        rejecteds.push({
          refundNo,
          refundAmount,
          approveComment,
        });
      } else if (refundStatus === 0) {
        pendings.push({
          refundNo,
          refundAmount,
          refundComment,
        });
      } else {
        resolves.push({
          refundNo,
          refundAmount,
          refundComment,
        });
      }
    });
  }

  return {
    pendings,
    rejecteds,
    rejectRemark,
    resolves,
  };
}

export function getRefundAmounts(order) {
  const { pendings, rejecteds, rejectRemark, resolves } =
    analyseRefundVos(order);

  const refundingAmount = pendings.reduce((p, c) => p + c.refundAmount, 0);
  const refundedAmount = resolves.reduce((p, c) => p + c.refundAmount, 0);

  return {
    refundingAmount,
    rejectedAmount: rejecteds.reduce((p, c) => p + c, 0),
    rejectRemark,
    refundedAmount,
    amount: refundingAmount + refundedAmount,
  };
}
